import { defineComponent as _defineComponent } from 'vue'
import { setBlockTracking as _setBlockTracking, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-662adecd"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import {
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardSubtitle,
    IonCardTitle,
} from '@ionic/vue';
import { TDocument } from '@/const/types/documents';
import { computed } from 'vue';

interface Props {
    document: TDocument;
    showDocumentCreator?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentSmall',
  props: {
    document: null,
    showDocumentCreator: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    document: TDocument;
    showDocumentCreator?: boolean;
};



const canShowDocumentCreator = computed<boolean>(() => {
    return Boolean(
        props.showDocumentCreator
        && props.document.created_by
        && props.document.user
    )
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonCard), { class: "card__outer" }, {
    default: _withCtx(() => [
      _cache[0] || (
        _setBlockTracking(-1),
        _cache[0] = _createVNode(_unref(IonCardHeader), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCardTitle), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.document.code), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCardSubtitle), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.document.expected_delivery_at) + " ", 1),
                _withDirectives(_createElementVNode("template", null, [
                  _createTextVNode(" | "),
                  _hoisted_1,
                  _createTextVNode(" " + _toDisplayString(props.document.supplier), 1)
                ], 512), [
                  [_vShow, props.document.supplier]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _setBlockTracking(1),
        _cache[0]
      ),
      _withDirectives(_createVNode(_unref(IonCardContent), null, {
        default: _withCtx(() => [
          (_unref(canShowDocumentCreator))
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                _createTextVNode(_toDisplayString(_ctx.$t('messages.Created by')) + ": " + _toDisplayString(props.document.user.first_name) + " " + _toDisplayString(props.document.user.last_name) + " ", 1),
                _hoisted_3
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(props.document.name) + ". ", 1),
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(props.document.note), 1)
        ]),
        _: 1
      }, 512), [
        [_vShow, props.document.note || props.document.name || props.document.created_by]
      ])
    ]),
    _: 1
  }))
}
}

})